import { useAppDispatch, useAppState } from '@/store';
import { useEffect } from 'react';
import { getProperty, selectPropertiesIsLoading, selectProperty, selectPropertyError, setProperty } from '../feature';

export const useGetPropertyDetails = (id?: string | null) => {
  const dispatch = useAppDispatch();

  const data = useAppState(selectProperty);
  const isLoading = useAppState(selectPropertiesIsLoading);
  const error = useAppState(selectPropertyError);

  useEffect(() => {
    if (!id || isLoading || error || data) return;
    dispatch(getProperty(id));
  }, [id, isLoading, error]);

  useEffect(() => {
    return () => {
      dispatch(setProperty(null));
    };
  }, []);

  return data;
};
